webpackJsonp([98614919688156],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { Grid, Row, Col } from 'react-flexbox-grid';
	
	var pageTitle = "Infrastructure";
	var pageContent = ["Besoin de conseils ou d'audits pour votre SI ? ", "Besoin spécifiques pour votre infrastructure ? ", "Un projet de développement ou de restructuration ?"];
	
	var Generic = function Generic(props) {
		return _react2.default.createElement(
			'div',
			{ style: props.transition && props.transition.style },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Web 2 Alpes - Assistance, conseil et audits des syst\xE8mes d\'information'
				),
				_react2.default.createElement('meta', { name: 'description', content: 'Assistance, conseil et audits des syst\xE8mes d\'information' }),
				_react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' })
			),
			_react2.default.createElement(_BannerLanding2.default, { title: pageTitle, content: pageContent, particles: 'infra' }),
			_react2.default.createElement(
				'div',
				{ id: 'main', className: 'alt' },
				_react2.default.createElement(
					'section',
					{ id: 'support', className: 'tiles' },
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Votre infrastructure'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								_react2.default.createElement(
									'strong',
									null,
									'Ing\xE9nieur syst\xE8mes r\xE9seaux et s\xE9curit\xE9'
								),
								', j\'interviens sur toute infrastructure d\'une dizaine de postes \xE0 plusieurs milliers. (Pour un parc plus petit, voir ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/assistance-informatique/' },
									'ici'
								),
								'). Je vous aide \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									'mettre en place une nouvelle infrastructure ou faire \xE9voluer la v\xF4tre'
								),
								'\xA0:'
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Analyse de vos besoins'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Audit'
									),
									' (d\xE9tection des failles et des axes d\u2019am\xE9lioration)'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Mise en \u0153uvre'
									),
									' (\xE9tude, conception et r\xE9alisation)'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'Vous trouverez le d\xE9tail de mes comp\xE9tences dans ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '/cv/' },
										'mon CV'
									)
								),
								'.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Une infra adaptee'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Selon vos besoins et vos pratiques, je peux optimiser votre infrastructure en favorisant travail collaboratif et mobilit\xE9 (gestion centralis\xE9e et partages de documents sur intranet ou internet...)'
							),
							_react2.default.createElement(
								'p',
								null,
								'Votre syst\xE8me d\u2019information doit maintenant respecter le cadre l\xE9gal europ\xE9en (GDPR) et peut \xEAtre soumis \xE0 des obligations sp\xE9cifiques relatives \xE0 votre activit\xE9. Je peux v\xE9rifier sa conformit\xE9 et le mettre aux normes.'
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Une infra economique'
								)
							),
							_react2.default.createElement(
								'p',
								null,
								'Concevoir un dispositif automatisant un maximum de t\xE2ches permet de gagner beaucoup de temps.'
							),
							_react2.default.createElement(
								'p',
								{ className: 'preul' },
								'Vous pouvez \xE9galement r\xE9duire vos frais d\u2019installation et de fonctionnement\xA0:'
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'en privil\xE9giant l\'open source gratuit,'
								),
								_react2.default.createElement(
									'li',
									null,
									'en n\xE9gociant le prix de vos licences,'
								),
								_react2.default.createElement(
									'li',
									null,
									'en \xE9vitant de surdimmensionner les services mis en place ...'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Mes garanties'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Une infrastructure\xA0',
									_react2.default.createElement(
										'strong',
										null,
										's\xE9curis\xE9e et conforme \xE0 la loi'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Un syst\xE8me d\u2019informations efficace'
									),
									', centr\xE9 sur vos besoins et pratiques'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Une optimisation \xE9conomique'
									),
									' \xE0 court, moyen et long terme'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Des interventions flexibles'
									),
									' : \xE0 la demande, ponctuelles ou suivies, sur l\u2019ensemble du syst\xE8me ou seulement une partie'
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'Une veille technologique et administrative constante'
									),
									'\xA0: je vous informe sur les nouveaut\xE9s et les changements l\xE9gaux vous concernant'
								)
							),
							_react2.default.createElement(
								'p',
								{ className: 'bordertop' },
								'N\u2019h\xE9sitez pas \xE0 ',
								_react2.default.createElement(
									'strong',
									null,
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: '#contact' },
										'me contacter'
									)
								),
								' pour un devis gratuit.'
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-infrastructure-informatique-js-f5e2a4b7728fab94edaf.js